import { useState, useEffect, useCallback } from 'react';

/**
 * When `src` 404s or is blocked, `onError` flips so callers can show initials instead of a
 * broken browser icon. Resets when `src` changes.
 */
export function useAvatarImageFallback(src) {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [src]);
  const onError = useCallback(() => setFailed(true), []);
  const showImage = Boolean(src) && !failed;
  return { showImage, onError };
}
